import React, { Component } from "react";
import config from 'react-global-configuration';
import axios from "axios";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

class TeamDashboardProductFilter extends Component {
    state = {
        productList: [],
        productValue: null,
        isLoading: true
    };

    componentDidMount() {
        this.getProducts();
    }

    resetProductFilter() {
        this.setState({ productValue: [] });
    }

    getProducts() {
        axios.get(config.get('API_URL') + '/filters/monday-okr/get-products', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            const productList = [];
            if (Array.isArray(response.data) && response.data.length) {
                response.data.forEach(product => {
                    productList.push({ value: product, label: product });
                });
            }
            this.setState({ productList, isLoading: false });
        }).catch(() => {
            this.setState({ isLoading: false });
        });
    }

    changeProduct(optionSelected) {
        let productArray = [];
        if (optionSelected && optionSelected.length > 0) {
            optionSelected.forEach(item => {
                productArray.push(item.value);
            });
        }
        this.props.onSelectProduct(optionSelected, productArray);
        this.setState({ productValue: optionSelected });
    }

    render() {
        return (
            <ReactMultiSelectCheckboxes
                name="product_list"
                isMulti
                value={this.state.productValue}
                styles={reactSelectStyles}
                className="report-listbox"
                isClearable={false}
                onChange={this.changeProduct.bind(this)}
                options={this.state.productList}
                placeholderButtonLabel="Select [Product]"
                isLoading={this.state.isLoading}
            />
        );
    }
}

export default TeamDashboardProductFilter;